import { Appointment } from "@elixir/types";
import { updateAppointment } from "../../utils/bridges/methods";
import { ControllerReturnType } from "../types";
import { logAndGetErrorResponse } from "../error";
import {
  trackAppointmentActivity,
  AptActivityType,
} from "./appointment-activity";

export default async function assignDoctor({
  appointment,
  doctorId,
}: {
  appointment: Pick<Appointment, "aid" | "doctor_oid">;
  doctorId: string;
}): Promise<ControllerReturnType> {
  try {
    const { aid, doctor_oid } = appointment;

    if (!doctor_oid.startsWith("c-")) {
      throw new Error("Doctor Already assigned");
    }

    await updateAppointment({ aid, data: { doctor_oid: doctorId } });
    trackAppointmentActivity({ aid, activity: AptActivityType.ASSIGN_DOCTOR });

    return { success: true };
  } catch (e) {
    return logAndGetErrorResponse(e);
  }
}
